/**
 * Reports this page's rendered height to a parent window embedding it in an
 * iframe, so the parent can size the iframe to fit without scrollbars.
 * Hand-authored static asset (not a wp-scripts build output), enqueued
 * directly by GWS_scripts() in functions.php.
 */
window.addEventListener( 'message', function ( event ) {
	var allowedExact = [ 'http://localhost', 'https://gws-internal.griffin-studio.co.uk' ];
	var isLocalNetwork = /^http:\/\/192\.168\.\d{1,3}\.\d{1,3}(:\d+)?$/.test( event.origin );

	if ( ! isLocalNetwork && allowedExact.indexOf( event.origin ) === -1 ) {
		return;
	}

	if ( event.data !== 'can I get your height?' ) {
		return;
	}

	var height = document.body.offsetHeight;
	window.parent.postMessage( JSON.stringify( { my_height: height } ), event.origin );
} );
